const constants = {
    GET_VIDEOS: 'GET_VIDEOS'
};

export default constants;



// WEBPACK FOOTER //
// ./src/constants/VideosConstants.js